import { CreateRootContextProvider } from './useCreateRoot';

export { useCreateRoot } from './useCreateRoot';
export type { ReactRoot, CreateRootFn } from './useCreateRoot';

export default CreateRootContextProvider;
